/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ConfirmPublicSeminarStripeCheckoutResponse = {
    status: ConfirmPublicSeminarStripeCheckoutResponse.status;
    id: string;
};
export namespace ConfirmPublicSeminarStripeCheckoutResponse {
    export enum status {
        PAID = 'paid',
        PENDING = 'pending',
        FAILED = 'failed',
    }
}

